export const MODULE_NAME = '@pressreader/social';
